import { render, staticRenderFns } from "./AlertInfo.vue?vue&type=template&id=60339450"
import script from "./AlertInfo.vue?vue&type=script&lang=ts"
export * from "./AlertInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports